import React, { ReactNode } from 'react';
import { BatchDownloadRes, EnumDocumentTypes } from './columns';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';

export const batchDownloadData: BatchDownloadRes[] = [
  {
    id: '0',
    submittedDate: '2023-03-21T00:00:00Z',
    from: '2023-03-21T00:00:00Z',
    to: '2023-03-21T00:00:00Z',
    accounts: '123',
    documentType: EnumDocumentTypes.eTax,
    status: 'active',
    type: 'Type Name',
    expiration: 'text',
  },
  {
    id: '1',
    submittedDate: '2023-03-21T00:00:00Z',
    from: '2023-03-21T00:00:00Z',
    to: '2023-03-21T00:00:00Z',
    accounts: '3453425',
    documentType: EnumDocumentTypes.statement,
    status: 'active',
    type: 'Type Name',
    expiration: 'text',
  },
  {
    id: '2',
    submittedDate: '2023-03-21T00:00:00Z',
    from: '2023-03-21T00:00:00Z',
    to: '2023-03-21T00:00:00Z',
    accounts: '342332',
    documentType: EnumDocumentTypes.notices,
    status: 'active',
    type: 'Type Name',
    expiration: 'text',
  },
  {
    id: '3',
    submittedDate: '2023-03-21T00:00:00Z',
    from: '2023-03-21T00:00:00Z',
    to: '2023-03-21T00:00:00Z',
    accounts: '23423',
    documentType: EnumDocumentTypes.eTax,
    status: 'active',
    type: 'Type Name',
    expiration: 'text',
  },
  {
    id: '4',
    submittedDate: '2023-03-21T00:00:00Z',
    from: '2023-03-21T00:00:00Z',
    to: '2023-03-21T00:00:00Z',
    accounts: '2342312',
    documentType: EnumDocumentTypes.statement,
    status: 'inactive',
    type: 'Type Name',
    expiration: 'text',
  },
  {
    id: '5',
    submittedDate: '2023-03-21T00:00:00Z',
    from: '2023-03-21T00:00:00Z',
    to: '2023-03-21T00:00:00Z',
    accounts: '2342317',
    documentType: EnumDocumentTypes.notices,
    status: 'inactive',
    type: 'Type Name',
    expiration: 'text',
  },
];

export enum DeliveryTypeEnum {
  'paperless' = 'Paperless',
  'paper' = 'Paper',
  'paperlessAndPaper' = 'Paperless & Paper',
}

export enum NotifyTypeEnum {
  'email' = 'Email',
  'emailTexts' = 'Email & SMS',
}

export interface IAccount {
  id: string;
  title: string;
  number: string;
  deliveryType: DeliveryTypeEnum;
  notify: NotifyTypeEnum;
  email?: string;
  phone?: string;
  attachment?: boolean;
  checked?: boolean;
}

export type IAccountType = 'checking' | 'loan' | 'savings' | 'business' | 'mortgage' | 'visa';

export interface IAccountData {
  id: string;
  label: string;
  type: IAccountType;
  icon: ReactNode | undefined;
  accounts: IAccount[];
  color: string;
}

export const accountData: IAccountData[] = [
  {
    id: '1',
    label: 'Checking',
    type: 'checking',
    color: '#1108B2',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Account',
        number: '****4560',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Checking',
        number: '****4561',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '2',
    label: 'Loan',
    type: 'loan',
    color: '#CBBB49',
    icon: <Icons.Loan />,
    accounts: [
      {
        id: '1',
        title: 'Personal Loan',
        number: '****4564',
        deliveryType: DeliveryTypeEnum.paperlessAndPaper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Car Loan',
        number: '****4565',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '3',
    label: 'Mortgage',
    type: 'mortgage',
    color: '#54c1fb',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Mortgage',
        number: '****4578',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Mortgage',
        number: '****4577',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '4',
    label: 'Savings',
    type: 'savings',
    color: '#479D4C',
    icon: <Icons.Saving />,
    accounts: [
      {
        id: '1',
        title: 'Rick’s Savings',
        number: '****4562',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Sally’s Savings',
        number: '****4563',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '3',
        title: 'Vacation Fund',
        number: '****4570',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '4',
        title: 'Emergency Fund',
        number: '****4561',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '5',
    label: 'Visa Classic',
    type: 'visa',
    color: '#b92d2d',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Visa',
        number: '****4585',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Visa',
        number: '****4591',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '6',
    label: 'Premier Business Checking',
    type: 'business',
    color: '#000',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'Business I LLC',
        number: '****4566',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Business I LLC',
        number: '****4567',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '3',
        title: 'Business I LLC',
        number: '****4568',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '4',
        title: 'Business I LLC',
        number: '****4601',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '5',
        title: 'Business I LLC',
        number: '****4602',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '6',
        title: 'Business I LLC',
        number: '****4602',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '7',
        title: 'Business I LLC',
        number: '****4603',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '8',
        title: 'Business I LLC',
        number: '****4604',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '9',
        title: 'Business I LLC',
        number: '****4605',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '10',
        title: 'Business I LLC',
        number: '****4606',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '22',
    label: 'Checking',
    type: 'checking',
    color: '#1108B2',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Account',
        number: '****4560',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Checking',
        number: '****4561',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '23',
    label: 'Loan',
    type: 'loan',
    color: '#CBBB49',
    icon: <Icons.Loan />,
    accounts: [
      {
        id: '1',
        title: 'Personal Loan',
        number: '****4564',
        deliveryType: DeliveryTypeEnum.paperlessAndPaper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Car Loan',
        number: '****4565',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '24',
    label: 'Mortgage',
    type: 'mortgage',
    color: '#54c1fb',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Mortgage',
        number: '****4578',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Mortgage',
        number: '****4577',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '25',
    label: 'Savings',
    type: 'savings',
    color: '#479D4C',
    icon: <Icons.Saving />,
    accounts: [
      {
        id: '1',
        title: 'Rick’s Savings',
        number: '****4562',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Sally’s Savings',
        number: '****4563',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '3',
        title: 'Vacation Fund',
        number: '****4570',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '4',
        title: 'Emergency Fund',
        number: '****4561',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '26',
    label: 'Visa Classic',
    type: 'visa',
    color: '#b92d2d',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Visa',
        number: '****4585',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Visa',
        number: '****4591',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '27',
    label: 'Premier Business Checking',
    type: 'business',
    color: '#000',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'Business I LLC',
        number: '****4566',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Business I LLC',
        number: '****4567',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '3',
        title: 'Business I LLC',
        number: '****4568',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '4',
        title: 'Business I LLC',
        number: '****4601',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '5',
        title: 'Business I LLC',
        number: '****4602',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      // {
      //   id: '6',
      //   title: 'Business I LLC',
      //   number: '****4602',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '7',
      //   title: 'Business I LLC',
      //   number: '****4603',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '8',
      //   title: 'Business I LLC',
      //   number: '****4604',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '9',
      //   title: 'Business I LLC',
      //   number: '****4605',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '10',
      //   title: 'Business I LLC',
      //   number: '****4606',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
    ],
  },
  {
    id: '28',
    label: 'Checking',
    type: 'checking',
    color: '#1108B2',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Account',
        number: '****4560',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Checking',
        number: '****4561',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '29',
    label: 'Loan',
    type: 'loan',
    color: '#CBBB49',
    icon: <Icons.Loan />,
    accounts: [
      {
        id: '1',
        title: 'Personal Loan',
        number: '****4564',
        deliveryType: DeliveryTypeEnum.paperlessAndPaper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Car Loan',
        number: '****4565',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '30',
    label: 'Mortgage',
    type: 'mortgage',
    color: '#54c1fb',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Mortgage',
        number: '****4578',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Mortgage',
        number: '****4577',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '31',
    label: 'Savings',
    type: 'savings',
    color: '#479D4C',
    icon: <Icons.Saving />,
    accounts: [
      {
        id: '1',
        title: 'Rick’s Savings',
        number: '****4562',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Sally’s Savings',
        number: '****4563',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '3',
        title: 'Vacation Fund',
        number: '****4570',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '4',
        title: 'Emergency Fund',
        number: '****4561',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '32',
    label: 'Visa Classic',
    type: 'visa',
    color: '#b92d2d',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'My Visa',
        number: '****4585',
        deliveryType: DeliveryTypeEnum.paper,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: true,
      },
      {
        id: '2',
        title: 'Jane’s Visa',
        number: '****4591',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
    ],
  },
  {
    id: '33',
    label: 'Premier Business Checking',
    type: 'business',
    color: '#000',
    icon: <Icons.UserCheck />,
    accounts: [
      {
        id: '1',
        title: 'Business I LLC',
        number: '****4566',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '2',
        title: 'Business I LLC',
        number: '****4567',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '3',
        title: 'Business I LLC',
        number: '****4568',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      {
        id: '4',
        title: 'Business I LLC',
        number: '****4601',
        deliveryType: DeliveryTypeEnum.paperless,
        notify: NotifyTypeEnum.email,
        phone: '5058971234',
        email: 'test@email.com',
        attachment: false,
      },
      // {
      //   id: '5',
      //   title: 'Business I LLC',
      //   number: '****4602',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '6',
      //   title: 'Business I LLC',
      //   number: '****4602',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '7',
      //   title: 'Business I LLC',
      //   number: '****4603',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '8',
      //   title: 'Business I LLC',
      //   number: '****4604',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
      // {
      //   id: '9',
      //   title: 'Business I LLC',
      //   number: '****4605',
      //   deliveryType: DeliveryTypeEnum.paperless,
      //   notify: NotifyTypeEnum.email,
      //   phone: '5058971234',
      //   email: 'test@email.com',
      //   attachment: false,
      // },
    ],
  },
];
